import React from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';

export const parcelFormatter = (cell, row) => (
  <MuiLink variant="subtitle1" component={Link} to={`/parcels/${row.id}`}>
    {row.number?.toUpperCase() || row.id}
  </MuiLink>
);

export const positionFormatter = cell => {
  if (!cell) {
    return '-';
  }

  return cell.toUpperCase();
};

export const shipmentFormatter = (cell, row) => {
  if (!row.shipment_id && !row.shipment_number) {
    return '-';
  }

  if (!row.shipment_id && row.shipment_number) {
    return row.shipment_number?.toUpperCase() || '-';
  }

  return (
    <MuiLink variant="subtitle1" component={Link} to={`/shipments/${row.shipment_id}`}>
      {row.shipment_number?.toUpperCase() || '-'}
    </MuiLink>
  );
};

export default parcelFormatter;
